/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    code: "code",
    pre: "pre",
    h3: "h3",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Attaching additional props | v2"
    }), "\n", _jsxs(_components.p, {
      children: ["To avoid unnecessary wrappers that just pass on some props to the rendered component or element, you can use the ", _jsxs(_components.a, {
        href: "/docs/api#attrs",
        children: [_jsx(_components.code, {
          children: ".attrs"
        }), " constructor"]
      }), ". It allows you to attach additional props (or \"attributes\") to a component."]
    }), "\n", _jsxs(_components.p, {
      children: ["This way you can for example attach static props to an element or pass a third-party prop like ", _jsx(_components.code, {
        children: "activeClassName"
      }), " to React Router's Link component. Furthermore, you can also attach more dynamic props to a component. The ", _jsx(_components.code, {
        children: ".attrs"
      }), " object also takes functions, that receive the props that the component receives. The return value will be merged into the resulting props as well."]
    }), "\n", _jsxs(_components.p, {
      children: ["Here we render an ", _jsx(_components.code, {
        children: "Input"
      }), " component and attach some dynamic and static attributes to it:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Input = styled.input.attrs<{ $size?: string; }>(props => ({\n  // we can define static props\n  type: \"text\",\n\n  // or we can define dynamic ones\n  $size: props.$size || \"1em\",\n}))`\n  color: #BF4F74;\n  font-size: 1em;\n  border: 2px solid #BF4F74;\n  border-radius: 3px;\n\n  /* here we use the dynamically computed prop */\n  margin: ${props => props.$size};\n  padding: ${props => props.$size};\n`;\n\nrender(\n  <div>\n    <Input placeholder=\"A small text input\" />\n    <br />\n    <Input placeholder=\"A bigger text input\" $size=\"2em\" />\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["As you can see, we get access to our newly created props in the interpolations, and the ", _jsx(_components.code, {
        children: "type"
      }), " attribute is passed down to the element."]
    }), "\n", _jsx(_components.h3, {
      children: "Overriding .attrs"
    }), "\n", _jsxs(_components.p, {
      children: ["Notice that when wrapping styled components, ", _jsx(_components.code, {
        children: ".attrs"
      }), " are applied from the innermost styled component to the outermost styled component."]
    }), "\n", _jsxs(_components.p, {
      children: ["This allows each wrapper to ", _jsx(_components.strong, {
        children: "override"
      }), " nested uses of ", _jsx(_components.code, {
        children: ".attrs"
      }), ", similarly to how CSS properties defined later in a stylesheet override previous declarations."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Input"
      }), "'s ", _jsx(_components.code, {
        children: ".attrs"
      }), " are applied first, and then ", _jsx(_components.code, {
        children: "PasswordInput"
      }), "'s ", _jsx(_components.code, {
        children: ".attrs"
      }), ":"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Input = styled.input.attrs<{ $size?: string }>((props) => ({\n\ttype: 'text',\n\t$size: props.$size || '1em',\n}))`\n\tborder: 2px solid #bf4f74;\n\tmargin: ${(props) => props.$size};\n\tpadding: ${(props) => props.$size};\n`;\n\n// Input's attrs will be applied first, and then this attrs obj\nconst PasswordInput = styled(Input).attrs({\n  type: \"password\",\n})`\n  // similarly, border will override Input's border\n  border: 2px solid aqua;\n`;\n\nrender(\n  <div>\n    <Input placeholder=\"A bigger text input\" $size=\"2em\" />\n    <br />\n    {/* Notice we can still use the size attr from Input */}\n    <PasswordInput placeholder=\"A bigger password input\" $size=\"2em\" />\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This is why ", _jsx(_components.code, {
        children: "PasswordInput"
      }), " is of a ", _jsx(_components.code, {
        children: "'password'"
      }), " type, but still uses the ", _jsx(_components.code, {
        children: "$size"
      }), " attribute from ", _jsx(_components.code, {
        children: "Input"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
